import { parseHTML } from 'linkedom';

function parseHtmlBody(html: string): Document {
    const { document } = parseHTML(`<!DOCTYPE html><html><body>${html}</body></html>`);
    return document;
}

/**
 * Strips paragraph tags from list items in HTML content.
 * Converts `<li><p>content</p></li>` to `<li>content</li>` by unwrapping
 * the paragraph element and moving its children directly into the list item.
 */
export function stripListItemParagraph(content: string): string {
    if (!content) {
        return '';
    }

    const doc = parseHtmlBody(content);
    const listItems = doc.querySelectorAll('li');
    for (const li of listItems) {
        const p = li.querySelector('p');
        if (p) {
            while (p.firstChild) {
                li.insertBefore(p.firstChild, p);
            }
            p.remove();
        }
    }
    return doc.body.innerHTML;
}

/**
 * Strips outer paragraph tags from rendered HTML content.
 * Multiple paragraphs are joined with <br> tags.
 */
export function stripOuterParagraphs(html: string): string {
    if (!html) {
        return '';
    }

    const doc = parseHtmlBody(html);
    return Array.from(doc.body.children)
        .map(el => (el.tagName === 'P' ? el.innerHTML : el.outerHTML))
        .join('<br>');
}
